import { render, staticRenderFns } from "./PCLoading.vue?vue&type=template&id=cc90272e&scoped=true"
import script from "./PCLoading.vue?vue&type=script&lang=js"
export * from "./PCLoading.vue?vue&type=script&lang=js"
import style0 from "./PCLoading.vue?vue&type=style&index=0&id=cc90272e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc90272e",
  null
  
)

export default component.exports